import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export var TelegramIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b;
    var iconSize = {
        sm: 'size-4',
        md: 'size-6',
        lg: 'size-8',
    };
    return (_jsx(_Fragment, { children: _jsx("svg", { viewBox: '0 0 14 12', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', className: iconSize[size], children: _jsx("path", { d: 'M13.5039 1.77539C13.6797 0.955078 13.2109 0.632812 12.6836 0.837891L1.02344 5.32031C0.232422 5.64258 0.261719 6.08203 0.90625 6.28711L3.86523 7.19531L10.7793 2.85938C11.1016 2.625 11.4238 2.77148 11.1602 2.97656L5.56445 8.01562L5.35938 11.0918C5.68164 11.0918 5.79883 10.9746 5.97461 10.7988L7.41016 9.39258L10.4277 11.6191C10.9844 11.9414 11.3945 11.7656 11.541 11.1211L13.5039 1.77539Z', fill: '#2266AA' }) }) }));
};
